import React, { useState, useEffect } from "react";
import HomeFooter from "../Home/Home/HomeFooter/HomeFooter";
import HomeFact from "../Home/Home/HomeFact/HomeFact";
import HomeHeader from "../Home/Home/HomeHeader/HomeHeader";
import AboutAppoinment from "./AboutAppoinment/AboutAppoinment";
import AboutArea from "./AboutArea/AboutArea";
import HomeThreeFaq from "../HomeThree/HomeThreeFaq/HomeThreeFaq";
import { buscarServico } from "../../hooks/getService";

const ReposicaoHormonal = () => {
  const [servicoData, setServicoData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const idArea = 1;
  const idServico = 12;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await buscarServico(idServico);
        if (data) {
          setServicoData(data);
        } else {
          console.error("Erro ao buscar dados do serviço.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [idServico]);

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const title = servicoData?.Nome || "Reposição Hormonal na Menopausa";
  const descricao =
    "Entendemos que o climatério e menopausa são fases que  podem trazer desafios únicos e sintomas desconfortáveis. </br>Estamos aqui para oferecer apoio e soluções personalizadas para ajudá-la a enfrentar essa transição com mais conforto e qualidade de vida";

  const precoAVista = servicoData?.Preco ? Number(servicoData.Preco) : 0;
  const parcela6x = servicoData?.Parcelas?.find(
    (p) => p.QuantidadeParcelas === 6
  )?.ValorParcela;
  const valorParcela6x = parcela6x ? Number(parcela6x) / 6 : 0;
  const price = servicoData
    ? `${formatarMoeda(precoAVista)} ou até 6x de ${formatarMoeda(
        valorParcela6x
      )}`
    : "Carregando preço...";

  const fatos = {
    titulo_fatos: "Priorize Seu Bem-Estar",
    descricao_fatos:
      "A menopausa é uma nova fase da vida que pode ser vivida com saúde e bem-estar. Com nosso serviço de cuidados com climatério e menopausa, você encontrará o suporte necessário para atravessar essa transição com confiança e serenidade.",
    subtitulos: [
      {
        titulo: "Cuidado integral",
        subtitulo:
          "Garantimos uma abordagem cuidadosa e individualizada para cada mulher Olis . Com o tratamento de reposição hormonal, você pode experimentar alívio dos sintomas como ondas de calor, suores noturnos, alterações de humor, ressecamento vaginal , problemas relacionados ao sono, além da prevenção de doenças, como osteoporose.",
      },
      {
        titulo: "Cuidado individualizado",
        subtitulo:
          "Se a reposição hormonal for considerada contraindicada para você, ofereceremos alternativas para ajudar a aliviar seus sintomas e melhorar sua qualidade de vida. Trabalharemos juntos para encontrar o melhor plano de tratamento adaptado às suas necessidades e circunstâncias individuais.",
      },
    ],
  };

  const passos = [
    {
      titulo: "Agendamento do serviço",
      descricao: "Escolha o melhor horário para você",
    },
    {
      titulo:
        "Envio de exames prévios para nosso link de whatsapp ,se houverem",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Recebimento do Link de Atendimento, via Whatsapp",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Consulta realizada por videochamada ( ~ 45 min)",
      descricao: "Aguarde o retorno",
    },
    {
      titulo:
        "Envio de exames prévios via link recebido pelo WhatsApp, se houverem",
      descricao: "Realize os exames",
    },
    {
      titulo: "Retorno em até 30 dias para ver seus exames.",
      descricao: "Aguarde o retorno",
    },
    {
      titulo: "Envio de relatório Médico",
      descricao: "Receba o relatório médico",
    },
  ];

  const imgUrl = "img/menopausa.png";

  if (isLoading) {
    return (
      <>
        <HomeHeader />
        <div style={{ textAlign: "center", padding: "50px" }}>
          <h2>Carregando...</h2>
        </div>
        <HomeFooter />
      </>
    );
  }

  return (
    <>
      <HomeHeader />
      <AboutArea
        imgUrl={imgUrl}
        title={title}
        descricao={descricao}
        price={price}
        idArea={idArea}
        idServico={idServico}
      />
      <HomeFact fatos={fatos} />
      <AboutAppoinment passos={passos} />
      <HomeThreeFaq />
      <HomeFooter />
    </>
  );
};

export default ReposicaoHormonal;
